"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[392],{

/***/ 60392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ RichText; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@graphcms/rich-text-types/dist/rich-text-types.esm.js
function isElement(node) {
  return node.children !== undefined;
}

function isText(node) {
  return node.text !== undefined;
}

function isEmpty(_ref) {
  var children = _ref.children;

  // Checks if the children array has more than one element.
  // It may have a link inside, that's why we need to check this condition.
  if (children.length > 1) {
    var hasText = children.filter(function f(child) {
      if (isText(child) && child.text !== '') {
        return true;
      }

      if (isElement(child)) {
        return (child.children = child.children.filter(f)).length;
      }

      return false;
    });
    return hasText.length > 0 ? false : true;
  } else if (children[0].text === '') return true;

  return false;
}

var EmptyElementsToRemove;

(function (EmptyElementsToRemove) {
  EmptyElementsToRemove[EmptyElementsToRemove["heading-one"] = 0] = "heading-one";
  EmptyElementsToRemove[EmptyElementsToRemove["heading-two"] = 1] = "heading-two";
  EmptyElementsToRemove[EmptyElementsToRemove["heading-three"] = 2] = "heading-three";
  EmptyElementsToRemove[EmptyElementsToRemove["heading-four"] = 3] = "heading-four";
  EmptyElementsToRemove[EmptyElementsToRemove["heading-five"] = 4] = "heading-five";
  EmptyElementsToRemove[EmptyElementsToRemove["heading-six"] = 5] = "heading-six";
  EmptyElementsToRemove[EmptyElementsToRemove["table_head"] = 6] = "table_head";
})(EmptyElementsToRemove || (EmptyElementsToRemove = {}));

var elementTypeKeys = {
  'heading-one': 'h1',
  'heading-two': 'h2',
  'heading-three': 'h3',
  'heading-four': 'h4',
  'heading-five': 'h5',
  'heading-six': 'h6',
  "class": 'class',
  link: 'a',
  image: 'img',
  iframe: 'iframe',
  video: 'video',
  'bulleted-list': 'ul',
  'numbered-list': 'ol',
  'list-item': 'li',
  'list-item-child': 'list_item_child',
  table: 'table',
  table_head: 'table_head',
  table_body: 'table_body',
  table_row: 'table_row',
  table_cell: 'table_cell',
  table_header_cell: 'table_header_cell',
  'block-quote': 'blockquote',
  paragraph: 'p',
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  code: 'code',
  'code-block': 'code_block'
};


//# sourceMappingURL=rich-text-types.esm.js.map

// EXTERNAL MODULE: ./node_modules/escape-html/index.js
var escape_html = __webpack_require__(95573);
var escape_html_default = /*#__PURE__*/__webpack_require__.n(escape_html);
;// CONCATENATED MODULE: ./node_modules/@graphcms/rich-text-react-renderer/dist/rich-text-react-renderer.esm.js




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Audio(_ref) {
  var url = _ref.url;
  return react.createElement("audio", {
    style: {
      display: 'block',
      maxWidth: '100%',
      height: 'auto'
    },
    src: url,
    controls: true
  }, react.createElement("p", null, "Your browser doesn't support HTML5 audio. Here is a", ' ', react.createElement("a", {
    href: url
  }, "link to the audio"), " instead."));
}

/* eslint-disable jsx-a11y/iframe-has-title */
function IFrame(_ref) {
  var url = _ref.url;
  return react.createElement("div", {
    style: {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      paddingTop: '56.25%'
    }
  }, react.createElement("iframe", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    src: escape_html_default()(url),
    loading: "lazy",
    allow: "fullscreen",
    frameBorder: "0",
    referrerPolicy: "no-referrer"
  }));
}

function Image(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      altText = _ref.altText,
      title = _ref.title;

  if (false) {}

  var shouldIncludeWidth = width && width > 0;
  var shouldIncludeHeight = height && height > 0;
  return react.createElement("img", Object.assign({
    loading: "lazy",
    src: escape_html_default()(src)
  }, shouldIncludeWidth && {
    width: width
  }, shouldIncludeHeight && {
    height: height
  }, {
    alt: altText,
    title: title
  }));
}

function Video(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      title = _ref.title;
  return react.createElement("video", {
    src: escape_html_default()(src),
    controls: true,
    width: width || '100%',
    height: height || '100%',
    title: title
  }, react.createElement("p", null, "Your browser doesn't support HTML5 video. Here is a", ' ', react.createElement("a", {
    href: src
  }, "link to the video"), " instead."));
}

function Class(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return react.createElement("div", {
    className: className
  }, children);
}

function Link(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var href = rest.href,
      rel = rest.rel,
      id = rest.id,
      title = rest.title,
      openInNewTab = rest.openInNewTab,
      className = rest.className;
  var props = {};
  if (rel) props.rel = rel;
  if (id) props.id = id;
  if (title) props.title = title;
  if (className) props.className = className;
  if (openInNewTab) props.target = '_blank';
  return react.createElement("a", Object.assign({
    href: escape_html_default()(href)
  }, props), children);
}

function FallbackForCustomAsset(_ref) {
  var mimeType = _ref.mimeType;

  if (false) {}

  return react.createElement(react.Fragment, null);
}

var defaultElements = {
  a: Link,
  "class": Class,
  video: Video,
  img: Image,
  iframe: IFrame,
  blockquote: function blockquote(_ref2) {
    var children = _ref2.children;
    return react.createElement("blockquote", null, children);
  },
  ul: function ul(_ref3) {
    var children = _ref3.children;
    return react.createElement("ul", null, children);
  },
  ol: function ol(_ref4) {
    var children = _ref4.children;
    return react.createElement("ol", null, children);
  },
  li: function li(_ref5) {
    var children = _ref5.children;
    return react.createElement("li", null, children);
  },
  p: function p(_ref6) {
    var children = _ref6.children;
    return react.createElement("p", null, children);
  },
  h1: function h1(_ref7) {
    var children = _ref7.children;
    return react.createElement("h1", null, children);
  },
  h2: function h2(_ref8) {
    var children = _ref8.children;
    return react.createElement("h2", null, children);
  },
  h3: function h3(_ref9) {
    var children = _ref9.children;
    return react.createElement("h3", null, children);
  },
  h4: function h4(_ref10) {
    var children = _ref10.children;
    return react.createElement("h4", null, children);
  },
  h5: function h5(_ref11) {
    var children = _ref11.children;
    return react.createElement("h5", null, children);
  },
  h6: function h6(_ref12) {
    var children = _ref12.children;
    return react.createElement("h6", null, children);
  },
  table: function table(_ref13) {
    var children = _ref13.children;
    return react.createElement("table", null, children);
  },
  table_head: function table_head(_ref14) {
    var children = _ref14.children;
    return react.createElement("thead", null, children);
  },
  table_body: function table_body(_ref15) {
    var children = _ref15.children;
    return react.createElement("tbody", null, children);
  },
  table_row: function table_row(_ref16) {
    var children = _ref16.children;
    return react.createElement("tr", null, children);
  },
  table_cell: function table_cell(_ref17) {
    var children = _ref17.children;
    return react.createElement("td", null, children);
  },
  table_header_cell: function table_header_cell(_ref18) {
    var children = _ref18.children;
    return react.createElement("th", null, children);
  },
  bold: function bold(_ref19) {
    var children = _ref19.children;
    return react.createElement("b", null, children);
  },
  italic: function italic(_ref20) {
    var children = _ref20.children;
    return react.createElement("i", null, children);
  },
  underline: function underline(_ref21) {
    var children = _ref21.children;
    return react.createElement("u", null, children);
  },
  code: function code(_ref22) {
    var children = _ref22.children;
    return react.createElement("code", null, children);
  },
  code_block: function code_block(_ref23) {
    var children = _ref23.children;
    return react.createElement("pre", {
      style: {
        whiteSpace: 'pre',
        wordWrap: 'break-word',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        fontFamily: 'monospace'
      }
    }, children);
  },
  list_item_child: function list_item_child(_ref24) {
    var children = _ref24.children;
    return react.createElement(react.Fragment, null, children);
  },
  Asset: {
    audio: function audio(props) {
      return react.createElement(Audio, Object.assign({}, props, {
        url: props.url
      }));
    },
    image: function image(props) {
      return react.createElement(Image, Object.assign({}, props, {
        src: props.url
      }));
    },
    video: function video(props) {
      return react.createElement(Video, Object.assign({}, props, {
        src: props.url
      }));
    },
    font: FallbackForCustomAsset,
    application: FallbackForCustomAsset,
    model: FallbackForCustomAsset,
    text: FallbackForCustomAsset
  },
  embed: {},
  link: {}
};

function serialize(text) {
  if (text.includes('\n')) {
    var splitText = text.split('\n');
    return splitText.map(function (line, index) {
      return react.createElement(react.Fragment, {
        key: index
      }, line, index === splitText.length - 1 ? null : react.createElement("br", null));
    });
  }

  return text;
}

function RenderText(_ref) {
  var textNode = _ref.textNode,
      renderers = _ref.renderers,
      shouldSerialize = _ref.shouldSerialize;
  var text = textNode.text,
      bold = textNode.bold,
      italic = textNode.italic,
      underline = textNode.underline,
      code = textNode.code;
  var parsedText = shouldSerialize ? serialize(text) : text;
  var Bold = renderers == null ? void 0 : renderers['bold'];
  var Italic = renderers == null ? void 0 : renderers['italic'];
  var Underline = renderers == null ? void 0 : renderers['underline'];
  var Code = renderers == null ? void 0 : renderers['code'];

  if (bold && Bold) {
    parsedText = react.createElement(Bold, null, parsedText);
  }

  if (italic && Italic) {
    parsedText = react.createElement(Italic, null, parsedText);
  }

  if (underline && Underline) {
    parsedText = react.createElement(Underline, null, parsedText);
  }

  if (code && Code) {
    parsedText = react.createElement(Code, null, parsedText);
  }

  return react.createElement(react.Fragment, null, parsedText);
}

function getArrayOfElements(content) {
  return Array.isArray(content) ? content : content.children;
}

function RenderNode(_ref) {
  var node = _ref.node,
      parent = _ref.parent,
      renderers = _ref.renderers,
      references = _ref.references;

  if (isText(node)) {
    var text = node.text;
    var shouldSerialize = parent && isElement(parent) && parent.type !== 'code-block';
    return react.createElement(RenderText, {
      textNode: _extends({}, node, {
        text: text
      }),
      renderers: renderers,
      shouldSerialize: shouldSerialize
    });
  }

  if (isElement(node)) {
    return react.createElement(RenderElement, {
      element: node,
      renderers: renderers,
      references: references
    });
  }

  var type = node.type;

  if (false) {}

  return react.createElement(react.Fragment, null);
}

function RenderElement(_ref2) {
  var element = _ref2.element,
      renderers = _ref2.renderers,
      references = _ref2.references;

  var children = element.children,
      type = element.type,
      rest = _objectWithoutPropertiesLoose(element, ["children", "type"]);

  var nodeId = rest.nodeId,
      nodeType = rest.nodeType; // Checks if the element is empty so that it can be removed.

  if (type in EmptyElementsToRemove && isEmpty({
    children: children
  })) {
    return react.createElement(react.Fragment, null);
  }

  var isEmbed = nodeId && nodeType;
  /**
   * The .filter method returns an array with all elements found.
   * Since there won't be duplicated ID's, it's safe to use the first element.
   */

  var referenceValues = isEmbed ? references == null ? void 0 : references.filter(function (ref) {
    return ref.id === nodeId;
  })[0] : null;
  /**
   * `id` is used to correctly find the props for the reference.
   * If it's not present, we show an error and render a Fragment.
   */

  if (false) {}
  /**
   * `mimeType` is used to determine if the node is an image or a video.
   * That's why this is required and we show an error if it's not present.
   * Only for custom assets embeds.
   */


  if (false) {}
  /**
   * `url` is needed to correctly render the image, video, audio or any other asset
   * Only for custom assets embeds.
   */


  if (false) {}
  /**
   * There's two options if the element is an embed.
   * 1. If it isn't an asset, then we simply try to use the renderer for that model.
   *  1.1 If we don't find a renderer, we render a Fragment and show a warning.
   * 2. If it is an asset, then:
   *  2.1 If we have a custom renderer for that specific mimeType, we use it.
   *  2.2 If we don't have, we use the default mimeType group renderer (application, image, video...).
   */


  var elementToRender; // Option 1

  if (isEmbed && nodeType !== 'Asset') {
    var _renderers$link, _renderers$embed;

    var _element = type === 'link' ? renderers == null ? void 0 : (_renderers$link = renderers.link) == null ? void 0 : _renderers$link[nodeType] : renderers == null ? void 0 : (_renderers$embed = renderers.embed) == null ? void 0 : _renderers$embed[nodeType];

    if (_element !== undefined) {
      elementToRender = _element;
    } else {
      // Option 1.1
      console.warn("[@graphcms/rich-text-react-renderer]: No renderer found for custom " + type + " nodeType " + nodeType + ".");
      return react.createElement(react.Fragment, null);
    }
  } // Option 2


  if (isEmbed && nodeType === 'Asset') {
    var _renderers$Asset;

    var _element2 = renderers == null ? void 0 : (_renderers$Asset = renderers.Asset) == null ? void 0 : _renderers$Asset[referenceValues == null ? void 0 : referenceValues.mimeType]; // Option 2.1


    if (_element2 !== undefined) {
      elementToRender = _element2;
    } else {
      var _renderers$Asset2;

      // Option 2.2
      var mimeTypeGroup = referenceValues == null ? void 0 : referenceValues.mimeType.split('/')[0];
      elementToRender = renderers == null ? void 0 : (_renderers$Asset2 = renderers.Asset) == null ? void 0 : _renderers$Asset2[mimeTypeGroup];
    }
  }

  var elementNodeRenderer = isEmbed ? elementToRender : renderers == null ? void 0 : renderers[elementTypeKeys[type]];
  var NodeRenderer = elementNodeRenderer;

  var props = _extends({}, rest, referenceValues);

  if (NodeRenderer) {
    return react.createElement(NodeRenderer, Object.assign({}, props), react.createElement(RenderElements, {
      content: children,
      renderers: renderers,
      references: references,
      parent: element
    }));
  }

  return react.createElement(react.Fragment, null);
}

function RenderElements(_ref3) {
  var content = _ref3.content,
      references = _ref3.references,
      renderers = _ref3.renderers,
      parent = _ref3.parent;
  var elements = getArrayOfElements(content);
  return react.createElement(react.Fragment, null, elements.map(function (node, index) {
    return react.createElement(RenderNode, {
      node: node,
      parent: parent || null,
      renderers: renderers,
      references: references,
      key: index
    });
  }));
}

function RichText(_ref4) {
  var content = _ref4.content,
      resolvers = _ref4.renderers,
      references = _ref4.references;

  // Shallow merge doensn't work here because if we spread over the elements, the
  // Asset object will be completly overriden by the resolvers. We need to keep
  // the default elements for the Asset that hasn't been writen.
  var assetRenderers = _extends({}, defaultElements == null ? void 0 : defaultElements.Asset, resolvers == null ? void 0 : resolvers.Asset);

  var renderers = _extends({}, defaultElements, resolvers, {
    Asset: assetRenderers
  });

  if (false) {}

  if (false) {}
  /*
    Checks if there's a embed type inside the content and if the `references` prop is defined
       If it isn't defined and there's embed elements, it will show a warning
    */


  if (false) { var embedElements, elements; }

  return react.createElement(RenderElements, {
    content: content,
    renderers: renderers,
    references: references
  });
}


//# sourceMappingURL=rich-text-react-renderer.esm.js.map


/***/ }),

/***/ 95573:
/***/ (function(module) {

/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */



/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;
}


/***/ })

}]);